<template>
    <div>
        <transition name="slide">
             
            <b-card :header="captionVideos">
                <b-form-checkbox-group stacked id="basicCustomCheckboxes">
                    <b-table
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive="sm"
                        :items="videosArray"
                        :fields="fieldsAttachments"
                        :current-page="currentPage"
                        :per-page="perPage"
                    >
                         <template slot="video" slot-scope="data">
                             <video width="100" controls :src="data.item.url"></video>
                        </template>
                        <template slot="title" slot-scope="data">
                            <strong>{{data.item.title}}</strong>
                        </template>
                        <template slot="description" slot-scope="data">
                            <strong>{{data.item.description}}</strong>
                        </template>
                        <template slot="viewButton" slot-scope="data">
                            <b-button :value="data.item" v-on:click="rowClickedRemove(data.item)" block variant="danger"><i class="fa fa-ban"></i>Remove</b-button>
                        </template>
                    </b-table>
                </b-form-checkbox-group>
                <nav>
                    <b-pagination
                        size="sm"
                        :total-rows="videosArray.length"
                        :per-page="perPage"
                        v-model="currentPage"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    />
                    <b-row class="align-items-center">
                        <b-col cols="6" class="mb-3 mb-xl-0">
                            <b-button v-on:click="addVideoButton" block variant="primary">Add Video</b-button>
                        </b-col>
                        <b-col cols="6" class="mb-3 mb-xl-0">
                            <b-button
                                v-if="videosSelected.length > 0"
                                v-on:click="removeMembersButton"
                                block
                                variant="danger"
                            >Remove Attachment(s)</b-button>
                        </b-col>
                    </b-row>
                </nav>
            </b-card>
        </transition>
        <b-modal title="Add an video" class="modal-primary" v-model="videoModal" @ok="addVideo">
            <b-form-group v-if="attachmentData.videoFile != null">
                <b-form-input
                    id="videoTitle"
                    type="text"
                    autocomplete="name"
                    v-model="attachmentData.title"
                    size="md"
                    placeholder="Enter video title..."
                ></b-form-input>
            </b-form-group>
            <b-form-group v-if="attachmentData.videoFile != null">
                <b-form-textarea
                    id="videoDescription"
                    v-model="attachmentData.description"
                    placeholder="Enter video description..."
                    :rows="3"
                    :max-rows="6"
                    size="sm"
                ></b-form-textarea>
            </b-form-group>
            <b-form-group
                label="Upload video"
                label-for="videoInput"
                :label-cols="3"
                :horizontal="true"
            >
                <b-form-file
                    accept="video/*"
                    id="videoInput"
                    :plain="true"
                    v-model="attachmentData.videoFile"
                ></b-form-file>
            </b-form-group>
            <b-form-group v-if="attachmentData.videoFile != null">
                <video controls :src="getVideoFile()" fluid alt="Responsive video"></video>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import _ from 'underscore'
import { db } from '@/config/devowqlo';
import { storage } from '@/config/devowqlo';
import CanvasVideo from 'vue-canvasvideo'
import 'vue-canvasvideo/dist/vuecanvasvideo.min.css'

export default {
    components: {
        CanvasVideo: CanvasVideo
    },
    name: "videoAttachment",
    props: {
        type: {
            type: String,
            default: ""
        },
        typeId: {
            type: String,
            default: ""
        },
        teamId: {
            type: String,
            default: ""
        },
        captionVideos: {
            type: String,
            default: "Videos"
        },
        hover: {
            type: Boolean,
            default: true
        },
        striped: {
            type: Boolean,
            default: true
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isEdit: false,
            currentTeam: null,
            attachmentData: {
                title: null,
                type: null,
                description: null,
                url: null,
                thumbUrl: null,
                videoFile: null
            },
            center: null,
            marker: null,
            teamsArray: [],
            teamsNamesArray: [],
            videosArray: [],
            videosSelected: [],
            videoModal: false,
            previewImage: null,
            previewImageUrl: null,
            fieldsAttachments: [
                // { key: "checkbox", label: "" },
                { key: "video" },
                { key: "title" },
                { key: "description" },
                { key: "viewButton", label: "Actions" }
            ],
            currentPage: 1,
            perPage: 5,
            totalRows: 0,
            KEY_TYPE_ATTACHMENT:  this.getKeyAttachment(),
            ST_TYPE_ATTACHMENT: this.getStAttachment(),
        };
    },
    created() {
        this.getVideos()
        console.log("type: ", this.type);
        console.log("typeId: ", this.typeId);
        console.log("teamId: ", this.teamId);
        console.log("teamId: ", this.KEY_TYPE_ATTACHMENT);
    },
    methods: {
        addVideoButton() {
            this.videoModal = true;
        },
        addVideo() {
            const dateNow = Date.now();
            console.log("Uploading video...");
            const videoName =
                +new Date() + "-" + this.attachmentData.videoFile.name;
            const videoMetadata = {
                contentType: this.attachmentData.videoFile.type
            };
            // 1. Save Image on Storage
            const uploadTask = storage
                .ref()
                .child(this.ST_TYPE_ATTACHMENT)
                .child("Videos")
                .child(videoName)
                .put(this.attachmentData.videoFile, videoMetadata)
                .then(snapshot => snapshot.ref.getDownloadURL())
                .then(url => {
                    const thumbImageUrl = "thumb_" + videoName;
                   
                   // 2. save on Database
                    var videoModel = {
                        title: this.attachmentData.title,
                        description: this.attachmentData.description,
                        type: "video",
                        url: videoName,
                        thumbUrl: thumbImageUrl,
                        created: dateNow
                    };
                    db.ref(this.KEY_TYPE_ATTACHMENT)
                        .child(this.teamId)
                        .child(this.typeId)
                        .child("videos")
                        .push(videoModel);
                });
        },
        getVideoFile() {
            console.log(this.attachmentData.videoFile);
            var reader = new FileReader();
            reader.onload = e => {
                this.previewImage = e.target.result;
            };
            reader.readAsDataURL(this.attachmentData.videoFile);
            return this.previewImage;
        }
        ,getVideos (){
            db.ref(this.KEY_TYPE_ATTACHMENT)
                .child(this.teamId)
                .child(this.typeId)
                .child("videos")
                .on('value', (snapshot) =>{

                this.videosArray = []
                console.log(snapshot.val())
                snapshot.forEach(childSnapshot => {
                    console.log("[]");
                    var videoObject = childSnapshot.val()
                    videoObject.key = childSnapshot.key
                    console.log(videoObject)
                    storage.ref().child(this.ST_TYPE_ATTACHMENT).child('Videos').child(videoObject.url).getDownloadURL().then((url) => {
                        
                        Object.assign(videoObject, {url: url});
                        this.videosArray.push(videoObject)
                        
                        console.log("*********");
                        console.log(this.videosArray);
                        
                    }).catch(function(error) {
                        // Handle any errors
                    });
                })
            })
        },
        rowClickedSee(data){
            console.log("?¿?¿");
            
            console.log(data.url);  
        },
        rowClickedRemove(data){
            db.ref(this.KEY_TYPE_ATTACHMENT)
                .child(this.teamId)
                .child(this.typeId)
                .child("videos")
                .set(null)
        }, 
        // Aux functions
        getKeyAttachment(){
            if (this.type == "training") {
                return "trainingAttachments"
            } else if (this.type == "match"){
                return "matchAttachments"
            }
        },
        getStAttachment(){
            if (this.type == "training") {
                return "TrainingAttachments"
            } else if (this.type == "match"){
                return "MatchAttachments"
            }
        }
    }
};
</script>

<style scoped>
</style>